export default "__VITE_ASSET__Bt8s$2zI__"